module.exports = "https://static.wanderu.com/static/media/kayak-logo.73d1e1d5.svg";